export default class SoundFile {
  constructor (file, audioContext, loadedCallback, unloadedCallback, context) {

    this.file = file;
    this.audioContext = audioContext;
    this.loadedCallback = loadedCallback;
    this.unloadedCallback = unloadedCallback;
    this.context = context;

    this.numInstances = 0;
    this.buffers = [];

    this.loading = false;

    this.paddingStart = 0;
    this.paddingEnd = 0;
  }

  loaded(){
    return(!this.loading && this.buffers.length > 0);
  }

  load(numInstances = 1) {
    //Always load at least one buffer
    if(numInstances < 1){numInstances = 1};

    //Check if already loaded
    if(this.loaded() || this.loading){
      return;
    }

    this.loading = true;

    this.numInstances = numInstances;

    fetch(this.file)
    .then(resp => {return resp.arrayBuffer()})
    .then(rawData => {
      this.audioContext.decodeAudioData(rawData,
        (buffer)=>{
          for(let i = 0; i < this.numInstances; i++){
            let instanceBuffer = this.audioContext.createBufferSource();
            instanceBuffer.buffer = buffer;
            this.buffers.push(instanceBuffer);
          }

          this.loading = false;
          this.loadedCallback(this);
        })
    });
  }

  reload(numInstances = -1) {
    //Always load at least one buffer
    if(numInstances < 0){
      numInstances = this.numInstances;
    }

    if(numInstances < 1){numInstances = 1};

    if(!this.loaded()){
      //We cache the reload request to be executed at loading time
      this.numInstances = numInstances;
      this.load(numInstances);
      return;
    }

    let dataBuffer = this.buffers[0].buffer;

    this.buffers.forEach((buffer, i) => {
      buffer.disconnect();
    });

    this.buffers = [];
    this.numInstances = numInstances;

    for(let i = 0; i< this.numInstances; i++){
      let instanceBuffer = this.audioContext.createBufferSource();
      instanceBuffer.buffer = dataBuffer;
      this.buffers.push(instanceBuffer);
    }

    this.loadedCallback(this);
  }

  unload() {
    //Hopefully this is enough to trigger garbage collection if the buffer source was disconnected
    this.buffers.forEach((buffer, i) => {
      buffer.disconnect();
    })

    this.buffers = [];
    this.numInstances = 0;
    this.unloadedCallback(this);
  }

  getBuffer(bufferId = 0){
    if(bufferId >= 0 && bufferId < this.numInstances){
      return this.buffers[bufferId];
    }
  }

}
